"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withInjectedLinkHandlers = void 0;
var _common = require("../config/common");
var _string = require("./type-checks/string");
var _reactRouterDom = require("react-router-dom");
var _react = _interopRequireWildcard(require("react"));
var _isLinkInternal = require("./isLinkInternal");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const merge = require("deepmerge");

/**
 * Higher order component to parse internal and external links
 *
 * @name withInjectedLinkHandlers
 * @param {node} WrappedComponent Wrapped Component
 * @param {object} props Properties passed to child object(s)
 * @returns {node} Transformed wrapped component
 */
const withInjectedLinkHandlers = function (WrappedComponent) {
  let configObject = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return props => {
    const {
        excludedPaths,
        ...rest
      } = props,
      config = merge({
        forceExternalDownload: false,
        forceInternalDownload: false
      }, configObject),
      navigate = (0, _reactRouterDom.useNavigate)();
    (0, _react.useEffect)(() => {
      const handleClickEvent = e => {
        const reFullProtocol = /^http/i,
          {
            target
          } = e,
          {
            nodeName
          } = target;
        if (nodeName.toLowerCase() === "a") {
          const to = target.getAttribute("href");
          if (target.hasAttribute(_common.HTML_DATA_ATTR_INJECTED)) {
            if ((0, _isLinkInternal.isLinkInternal)(to) && !reFullProtocol.test(to) && !(0, _isLinkInternal.isTargetBlank)(target) && !(0, _isLinkInternal.isExcludedPath)(to, excludedPaths)) {
              if (config.forceInternalDownload === true && (0, _isLinkInternal.isDownloadFile)(to)) {
                target.setAttribute("download", "download");
              } else {
                e.preventDefault();
                navigate(to);
              }
            } else if (!(0, _string.isStringOfLength)(target.target)) {
              if (config.forceExternalDownload === true && (0, _isLinkInternal.isDownloadFile)(to)) {
                target.setAttribute("download", "download");
              } else {
                target.setAttribute("target", "_blank");
              }
            }
          }
        }
      };
      document.addEventListener("click", handleClickEvent);
      return () => {
        document.removeEventListener("click", handleClickEvent);
      };
    }, [excludedPaths, config, navigate, props]);
    return /*#__PURE__*/_react.default.createElement(WrappedComponent, rest);
  };
};
exports.withInjectedLinkHandlers = withInjectedLinkHandlers;